import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { map } from "rxjs/operators";
import { MedicinService } from "../services/index";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
public pdfbase64decode:any;
public domainAffilateData: any;
  constructor(private sanitizer:DomSanitizer, private ms: MedicinService,   private location: Location) { 

    let stext=this.location.path().replace('/','');
    if(stext.split('/').length>1){
this.Page_Forward(stext.split('/')[1]);
    }
  }

  ngOnInit() {
  }
  Page_Forward(stext:string)
  {
    if(stext != ''){
      try{
      this.ms.GetDomainAffiliate(stext).pipe(map(res => res.json()))
      .subscribe(data => {
        if (data.length > 0) {
          if(data[0].pdf64!=null)
          {
          this.domainAffilateData = data;
          }
          else{
            window.location.href=window.location.origin+'/'+stext;  
          }
        }
        else {
          window.location.href=window.location.origin+'/'+stext;
        }
      });
    }
    catch(error){
    }
    }
  }
  transformpdf(base64pdf){
    if(base64pdf)
    {
    return this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,'+base64pdf);
    }
  }
}
